import { Config, configureChains, createConfig } from "wagmi";
import { publicProvider } from "wagmi/providers/public";
import { jsonRpcProvider } from "wagmi/providers/jsonRpc";
import * as Sentry from "@sentry/browser";
import { Chain, connectorsForWallets } from "@rainbow-me/rainbowkit";
import {
  coinbaseWallet,
  injectedWallet,
  metaMaskWallet,
  phantomWallet,
  rabbyWallet,
  rainbowWallet,
  walletConnectWallet,
  xdefiWallet,
  zerionWallet,
} from "@rainbow-me/rainbowkit/wallets";

import { MockConnector } from "@wagmi/connectors/mock";
import { PROJECT_NAME } from "config/consts";
import { exodusWallet } from "../config/connectors/exodusWallet/exodusWallet";
import { CHAINS, SUPPORTED_CHAINS } from "config/chains";

const WALLET_CONNECT_PROJECT_ID = "ce6a900e4631f5d75cd6984f0ed4e383";

export const bootstrapWagmi = () => {
  const { publicClient, chains, webSocketPublicClient } = configureChains<Chain>(
    SUPPORTED_CHAINS,
    [
      jsonRpcProvider({
        rpc: chain => {
          const url = CHAINS[chain.id].rpcUrl;
          return {
            http: url,
          };
        },
      }),
      publicProvider(),
    ],
    { stallTimeout: 5000 }
  );

  const wallets = [
    zerionWallet({
      projectId: WALLET_CONNECT_PROJECT_ID,
      chains,
    }),
    injectedWallet({ chains, shimDisconnect: true }),
    metaMaskWallet({ chains, projectId: WALLET_CONNECT_PROJECT_ID }),
    rainbowWallet({ chains, projectId: WALLET_CONNECT_PROJECT_ID }),
    coinbaseWallet({ chains, appName: PROJECT_NAME }),
    walletConnectWallet({ chains, projectId: WALLET_CONNECT_PROJECT_ID }),
    phantomWallet({ chains, shimDisconnect: true }),
    exodusWallet({
      chains,
      shimDisconnect: true,
    }),
    xdefiWallet({
      chains,
      shimDisconnect: true,
    }),
    rabbyWallet({
      chains,
    }),
  ];
  const customConnectors = connectorsForWallets([
    {
      groupName: "Recommended",
      wallets,
    },
  ]);
  const WAGMI_CONFIG = {
    autoConnect: true,
    publicClient,
    webSocketPublicClient,
    logger: {
      warn: (warning: string) => {
        console.warn(warning);
        Sentry.captureException(warning, {
          extra: { source: "wagmi" },
        });
      },
    },
    connectors: customConnectors,
  };
  const reactClient = createConfig(WAGMI_CONFIG);
  return reactClient as Config;
};

export const createMockWagmiConfig = (mockConnector: MockConnector) => {
  const { publicClient } = configureChains<Chain>(
    SUPPORTED_CHAINS,
    [
      jsonRpcProvider({
        rpc: chain => {
          const url = CHAINS[chain.id].rpcUrl;
          return {
            http: url,
          };
        },
      }),
      publicProvider(),
    ],
    { stallTimeout: 5000 }
  );
  return createConfig({
    publicClient,
    connectors: [mockConnector],
  });
};
